import type { RelatorioV2Row } from '../services/relatorioV2Service'

export function groupByKey<T extends RelatorioV2Row>(
  rows: T[],
  keyFn: (row: T) => string,
): Array<{ key: string; rows: T[] }> {
  const m = new Map<string, T[]>()
  for (const r of rows) {
    const k = String(keyFn(r) || '').trim() || '(vazio)'
    const arr = m.get(k) || []
    arr.push(r)
    m.set(k, arr)
  }
  return Array.from(m.entries()).map(([key, grouped]) => ({ key, rows: grouped }))
}

export function sortGroupsByTotalDesc(groups: Array<{ key: string; rows: RelatorioV2Row[] }>) {
  return [...groups].sort((a, b) => b.rows.length - a.rows.length)
}
